import { AIChatBlockSchema } from '@affine/core/blocksuite/ai/blocks/ai-chat-block/model';
import { TranscriptionBlockSchema } from '@affine/core/blocksuite/ai/blocks/transcription-block/model';
// TUNINHO: sem esta linha o `ZipTransformer` DESCARTA o bloco de gráfico ao importar um
// documento — em silêncio, e só no caminho de importação. Card 1850168865112196130.
import { TuninhoChartBlockSchema } from '@affine/core/blocksuite/blocks/tuninho-chart';
import { AffineSchemas } from '@blocksuite/affine/schemas';
import { Schema } from '@blocksuite/affine/store';

let _schema: Schema | null = null;
export function getAFFiNEWorkspaceSchema() {
  if (!_schema) {
    _schema = new Schema();

    _schema.register([
      ...AffineSchemas,
      AIChatBlockSchema,
      TranscriptionBlockSchema,
      TuninhoChartBlockSchema,
    ]);
  }

  return _schema;
}
